import React from "react";
import Report from "../../../components/Report/Report";

const Registration = () => {
  return <Report type={"registration"} />;
};

export default Registration;
